<template>
  <main>
    <section class="fk-contents">
      <h2 class="title-lv4 mb20">{{getSelectCategory.category_name}}</h2>
      <ul class="fk-menu-item-select">
        <li v-for="(item, index) in itemList" :key="index" :class="item.is_sales || 'disabled'" :ref="item.item_cd">
          <a href="#" @click.prevent="executeSelect($event, index)" v-if="item.is_sales">
            <span class="text">{{item.category_name}}</span>
            <span class="thumb"><img :src="item.image_url" :alt="item.category_name"></span>
          </a>
          <span v-if="!item.is_sales">
            <span class="text">{{item.category_name}}</span>
            <span class="thumb"><b v-html="$t('Cart.Discontinued')"></b></span>
          </span>
        </li>
      </ul>
    </section>
  </main>
</template>

<script>
import CommonMixin from '@/mixins/CommonMixin'
import AddSingleItemMixin from '@/mixins/AddSingleItemMixin'
import DisplayErrorMixin from '@/mixins/DisplayErrorMixin'
export default {
  name: 'FKMOMenuList',
  mixins: [ CommonMixin, AddSingleItemMixin, DisplayErrorMixin ],
  data () {
    return {
      itemList: []
    }
  },
  computed: {
    getServerTime () {
      return this.$store.getters.serverTime
    },
    getSelectCategory () {
      return this.$store.getters.selectCategory
    },
    getSelectItem () {
      return this.$store.getters.selectItem
    },
    getReceiveMethod () {
      return Number(this.$store.getters.cart.receive_method)
    },
    getSelectStore () {
      return this.$store.getters.selectStore
    },
    getDisabledButton () {
      return this.$store.getters.disabledButton
    },
    getIsAcceptingMenu () {
      return this.$store.getters.isAcceptingMenu
    }
  },
  watch: {
    $route (to, from) {
      // サーバー時間
      this.serverTime = this.getServerTime

      this.init()
    }
  },
  methods: {
    /**
     * executeNext
     * クリックしたボタンに非活性属性が付与されている場合は処理をしない。そうでなければページ遷移を実行する。
     */
    executeSelect: function (event, index) {
      if (this.getDisabledButton) {
        return false
      }

      const selectItem = {
        coupon: this.getSelectItem.coupon,
        item: this.getSelectItem.item,
        quantity: this.getSelectItem.quantity,
        setmenu: this.getSelectItem.setmenu,
        setmenu_details: []
      }

      // 対象のカテゴリを検索する
      const item = this.itemList[index]

      selectItem.item = item

      // item_typeによって処理を振り分ける
      switch (item.item_type) {
        case 0: // カテゴリ
          if (item.is_terminate) {
            // カテゴリ終端であればセットメニューリストに遷移する
            this.$store.dispatch('setSelectItem', selectItem)
            this.$router.push({ name: 'SetMenuList' })
          } else {
            // 次のカテゴリへ遷移する
            this.$router.push({
              name: 'MenuList',
              query: {
                q: this.CryptoJS.AES.encrypt(item.category_cd, 'a/z8msFn36sgB42-sMdn7Bg').toString()
              }
            })
          }
          break
        case 1: // 単品
          // カートに単品商品を追加する
          this.$store.dispatch('setSelectItem', selectItem)
          this.addSingleItem2(selectItem)
          break
        case 2: // セットメニュー
          // セットメニュー詳細に遷移する
          let setmenu = {
            'item_type': item.item_type,
            'is_terminate': item.is_terminate,
            'category_cd': item.category_cd,
            'category_name': item.category_name,
            'price': item.price,
            'tax_type': item.tax_type,
            'is_sales': item.is_sales,
            'image_url': item.image_url
          }
          selectItem.setmenu = setmenu
          this.$store.dispatch('setSelectItem', selectItem)
          this.$router.push({ name: 'SetMenuDetail' })
          break
      }
    },
    init: function () {
      this.setDisabledButton(true)
      // axios callback内からの参照用
      let that = this

      // typeを決定する
      let type
      if (this.getIsAcceptingMenu.morning) {
        type = 1
      } else if (this.getIsAcceptingMenu.grand) {
        type = 2
      }

      // カテゴリー一覧を取得する
      let params = {
        'store_cd': this.getSelectStore.store_cd,
        type,
        'category_cd': this.getSelectCategory.category_cd,
        'receive_method': this.getReceiveMethod,
        language: sessionStorage.getItem('lang')
      }
      this.callApi('GetCategoryItem',
        params
      )
      // this.axios.get(stuburl)
        .then(function (res) {
          if (res.data.result) {
            that.itemList = res.data.value.category_list

            // リストテンプレートを生成する
            for (let i = 0; i < that.itemList.length; i++) {
              // 画像をバインディングする
              that.itemList[i].image_url = that.importImageUri(that.itemList[i].image_url)
            }
          } else {
            that.errorFromApi(res.data.errorCode, res.data.error)
          }
        })
        .catch((error) => {
          that.errorFromAxios(error)
        })
        .finally(() => {
          that.setDisabledButton(false)
        })
    }
  },
  beforeMount () {
    // サーバー時間
    this.serverTime = this.getServerTime

    this.init()
  },
  beforeUpdate () {
    this.restoreScaleRate('default') // 拡大縮小のロックを開放
  },
  destroyed () {
    this.restoreScaleRate('reset') // scaleをリセット
  }
}
</script>



// WEBPACK FOOTER //
// src/components/MenuList.vue